import useLiterals from 'utils/hooks/useLiterals';
import { useNavigate } from 'react-router-dom';
import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import { ROUTE_PATH } from 'routes';
import CmsBlocks from 'components/CmsBlocks/v2';
import { EFFECT_LIST_BOX_UP_IN_VIEW } from 'constants/effects';
import { BOTTOM_MENU_ACTIONS } from 'components/Layout/components/BottomMenu';

const Services = () => {
  const navigate = useNavigate();
  const literals = useLiterals('services');

  const handleGoBack = () => {
    navigate(ROUTE_PATH.HOME);
  };

  return (
    <Layout
      title={literals.title}
      onBack={handleGoBack}
      bottomMenu={{
        type: BOTTOM_MENU_ACTIONS.AUTOMATIC_QUOTER,
      }}
    >
      <AppShell>
        <CmsBlocks animate={EFFECT_LIST_BOX_UP_IN_VIEW} />
      </AppShell>
    </Layout>
  );
};

export default Services;
